import React from 'react';
import PropTypes from 'prop-types';
import ActionsIcon from 'components/grid/table/components/actions/components/actions-icon';
import { ActionsContainer } from 'components/grid/table/components/actions/style';
import { isFunction, debounce } from 'lodash';

class Actions extends React.Component<any> {
  static type = 'actionsComponent';

  static propTypes = {
    hide: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    show: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    render: PropTypes.func,
    children: PropTypes.any,
    data: PropTypes.object,
    rowNumber: PropTypes.number,
  };

  static defaultProps = {
    show: true,
    hide: false,
    children: undefined,
    render: undefined,
    data: undefined,
    rowNumber: undefined,
  };

  scrollY = 0;

  state = {
    menuVisible: false,
  };

  componentDidMount() {
    this.scrollY = window.scrollY;
  }

  shouldHide = () => {
    let { hide, show } = this.props;

    if (hide) {
      hide = isFunction(hide) ? hide(this.props.data) : hide;
    }

    if (show) {
      show = isFunction(show) ? show(this.props.data) : show;
    }

    return hide || !show;
  };

  toggleMenu = () => {
    this.menuVisible(({ menuVisible }) => ({
      menuVisible: !menuVisible,
    }));
  };

  hideMenu = () => {
    if (this.state.menuVisible) {
      this.menuVisible(false);
    }
  };

  menuVisible = debounce((menuVisible) => {
    const argument = isFunction(menuVisible) ? menuVisible : { menuVisible };
    this.setState(argument);
  }, 200);

  render() {
    const { render, rowNumber } = this.props;

    if (this.shouldHide()) {
      return null;
    }

    if (render) {
      return render.call(this);
    }

    const { menuVisible } = this.state;

    return (
      <ActionsContainer
        menuVisible={menuVisible}
        data-type="actions"
        data-name={`actions-${rowNumber + 1}`}>
        <ActionsIcon onClick={this.toggleMenu} data-type="icon" />
      </ActionsContainer>
    );
  }
}

export default Actions;
